import React from 'react';

const Page = ({ title, children }) => (
  <div className="mx-auto max-w-4xl px-6 py-16">
    <h1 className="mb-8 text-4xl font-bold text-navy">{title}</h1>
    {children}
  </div>
);

export default Page;
